import { render, staticRenderFns } from "./carnet.vue?vue&type=template&id=00525f3a&"
import script from "./carnet.vue?vue&type=script&lang=js&"
export * from "./carnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports